'use strict';

import React, { useCallback, useEffect, useState } from 'react';
import { PlayLogo } from './PlayLogo.styles';
import MenuItem from '../MenuItem/MenuItem';
import { ListItem } from '../MenuItem/MenuItem.styles';
import AutoCompleteSearchFormContainer from '../../AutoCompleteSearch/AutoCompleteSearchFormContainer.jsx';
import { Navigation, LogoText, MenuItems, SearchToggle, SearchListItem } from './Menu.styles.js';
import { useRouter } from 'next/router';
import { VisuallyHiddenStyle } from 'app/ui-components/utils.styles';

export const Menu = (props) => {
    const router = useRouter();
    const [activeMobileSearch, setActiveMobileSearch] = useState(false);

    const onMobileSearchClick = useCallback(
        (e) => {
            setActiveMobileSearch(!activeMobileSearch);
        },
        [activeMobileSearch]
    );

    const onMobileSearchKeyDown = useCallback(
        (e) => {
            if (e.which === 13 || e.which === 32) {
                e.preventDefault();
                setActiveMobileSearch(!activeMobileSearch);
            }
        },
        [activeMobileSearch]
    );

    useEffect(() => {
        const video = document.getElementById('campaign-hero-video');

        if (video) {
            video.style.opacity = activeMobileSearch ? '0' : '1';
        }
    }, [activeMobileSearch]);

    return (
        <Navigation aria-label="topp-navigation" data-rt="play-navigation">
            <PlayLogo to="/" tabIndex="-1" regTestSpec="play-logo">
                <LogoText>SVT Play</LogoText>
            </PlayLogo>
            <MenuItems>
                <MenuItem
                    route="/"
                    accessKey="1"
                    text="Start"
                    type="start"
                    index={1}
                    currentPath={router.pathname}
                />
                <MenuItem
                    route="/program"
                    accessKey="2"
                    text="Program"
                    type="programs"
                    index={2}
                    currentPath={router.pathname}
                />
                <MenuItem
                    route="/kanaler"
                    accessKey="3"
                    text="Kanaler"
                    type="channels"
                    index={3}
                    currentPath={router.pathname}
                />
                <ListItem type="search">
                    <input
                        hidden
                        type="checkbox"
                        id="search-mobile-toggle"
                        name="search-mobile-toggle"
                        onChange={onMobileSearchClick}
                    />
                    <SearchToggle
                        tabIndex={0}
                        htmlFor="search-mobile-toggle"
                        onKeyDown={onMobileSearchKeyDown}
                        aria-label="Visa sökfältet"
                    >
                        <span aria-hidden="true">Sök</span>
                        <VisuallyHiddenStyle>
                            {activeMobileSearch ? 'Dölj sökfältet' : 'Visa sökfältet'}
                        </VisuallyHiddenStyle>
                    </SearchToggle>
                </ListItem>
                <SearchListItem hiddenXs={!activeMobileSearch}>
                    <AutoCompleteSearchFormContainer {...props} activeMobileSearch={activeMobileSearch} />
                </SearchListItem>
            </MenuItems>
        </Navigation>
    );
};

export default Menu;
